import React, { useState, useEffect } from "react";
import {
  useWallet,
  WalletStatus,
  useConnectedWallet,
  UserDenied,
} from "@xpla/wallet-provider";

import { LCDClient, MsgSend } from "@xpla/xpla.js";
import "./Aishop.css";
import "./WalletModal.css";

// 암호화 
import CryptoJS from "crypto-js";

const secretKey = "btn_KEY_#1125";

const apiUrl = process.env.REACT_APP_API_URL;
const recipient = process.env.REACT_APP_WALLET_ADDRESS;

const chainid = process.env.REACT_APP_XPLA_CHAINID;
const xplaurl = process.env.REACT_APP_XPLA_URL;

// 네트워크 검증을 위한 상수 추가
const EXPECTED_NETWORK = chainid === "dimension_37-1" ? "mainnet" : "testnet";
const NETWORK_DISPLAY_NAME = EXPECTED_NETWORK === "mainnet" ? "MAINNET" : "TESTNET";

// 모바일 감지 함수 - 컴포넌트 외부에서 즉시 실행
const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// 초기값들을 미리 계산
const IS_MOBILE = isMobileDevice();
const IS_XPLA_INSTALLED = IS_MOBILE ? true : (typeof window.xplaWallets !== "undefined");

// 상품 목록 확장 (6개)
const products = [
  {
    pid: "1001-1",        // 잼  
    icon: "1001-1",
    name: "Gem 240",       // 잼 표시 
    price: "₩3,000",     // 한화 가격
    
//   amount: "2", // axpla 단위  아래서 계산 하여 처리 함
//   xplaPrice: "2.000000",        // 표시 가격
    
    amount: "50", // axpla 단위  아래서 계산 하여 처리 함
    xplaPrice: "50.000000",        // 표시 가격
    cnt: 240                  // 잼 수량
  },
  {
    pid: "1001-1",
    icon: "1001-2",
    name: "Gem 720",
    price: "₩7,500",
    amount: "125",
    xplaPrice: "125.000000",
    cnt: 720
  },
  {
    pid: "1001-1",
    icon: "1001-3",
    name: "Gem 1680",
    price: "₩15,000",
    amount: "250",
    xplaPrice: "250.000000",
    cnt: 1680
  },
  {
    pid: "1001-1",
    icon: "1001-4",
    name: "Gem 3480",
    price: "₩30,000",
    amount: "500",
    xplaPrice: "500.00000",
    cnt: 3480
  },
  {
    pid: "1001-1",
    icon: "1001-5",
    name: "Gem 9000",
    price: "₩79,000",
    amount: "1300",
    xplaPrice: "1300.00000",
    cnt: 9000
  },
  {
    pid: "1001-1",
    icon: "1001-6",
    name: "Gem 18960",
    price: "₩150,000",
    amount: "2500",
    xplaPrice: "2500.00000",
    cnt: 18960
  }
];

export default function WalletModal({
  show,
  onClose,
  openTelegram,
  purchaseItem,
  onConnectHavah,
  onConnectXPLA,
  onConnectWalletConnect,
  children
})  {
	// 미리 계산된 값들 사용
	const [isXplaInstalled] = useState(IS_XPLA_INSTALLED);
	const [isMobile] = useState(IS_MOBILE);
	const connectedWallet = useConnectedWallet();
	const [loading, setLoading] = useState(1);
	const [txResult, setTxResult] = useState(null);
	const [txError, setTxError] = useState(null);
	
	// 사용자 입력 값 추가 
	const [showCheckoutModal, setShowCheckoutModal] = useState(false);
	const [inputUserId, setInputUserId] = useState("");
	const [selectedProduct, setSelectedProduct] = useState(null);
	
	// state 추가 (컴포넌트 상단에)
	const [showWalletInstallModal, setShowWalletInstallModal] = useState(false);
	const [showWalletMenu, setShowWalletMenu] = useState(false);
    
   // console.log("xpla_url:", xplaurl);
    
   
    
    const lcd = new LCDClient({
		URL: xplaurl,
		chainID: chainid
    });
    
   const {
        status,
        network,
        wallets,
        connect,
        disconnect
    } = useWallet();

	//const handleSend = async (id,recipient, amount) => {
	const handleSend = async (product) => {
		  const { pid,  amount , userId, cnt} = product;
		  
		  // 네트워크 검증 추가
		  if (network && network.name !== EXPECTED_NETWORK) {
		      alert(`⚠️ Wrong Network!\n\nYou are connected to ${network.name.toUpperCase()}\nPlease switch to ${NETWORK_DISPLAY_NAME} in your wallet.\n\nThis shop only accepts ${NETWORK_DISPLAY_NAME} transactions.`);
		      return;
		  }
		  
		  // chainID 추가 검증
		  if (network && network.chainID !== chainid) {
		      alert(`⚠️ Network Mismatch!\n\nExpected: ${chainid}\nCurrent: ${network.chainID}\n\nPlease switch to the correct network.`);
		      return;
		  }
		  
		  // id, recipient, amount를 활용하여 송금 및 로깅 등 처리
  	//	console.log("handleSend 함수 시작");
  	//	console.log("상품ID:", pid, "받는사람:", recipient, "금액:", amount, "사용자ID:" , userId, "상품 수량:" , cnt);
  		
  	//	console.log("Recipient address:", recipient);
  		
  		//amount = BigInt(Math.round(Number(amount) * 1_000_000_000_000_000_000));
  		const amountBigInt = BigInt(Math.round(Number(amount) * 1_000_000_000_000_000_000));
  		
  	    if (!connectedWallet || !connectedWallet.walletAddress) {
    		alert("Your wallet is not connected. Please connect your wallet first. ");
    		return;
  		}
  		
	    try {
	        const transactionMsg = {
	            msgs: [
	                new MsgSend(connectedWallet.walletAddress, recipient, {
	                    axpla: amountBigInt
	                }),
	            ],
	        };
	        const tx = await connectedWallet.post(transactionMsg);
	        if (tx.success) {
	            setLoading(true);
	            setTxResult(tx);
	            
				const response = await fetch(apiUrl, {
				  method: 'POST',
				  headers: {
				    'Content-Type': 'application/json',
				  },
				  body: JSON.stringify({
					playerid:userId,
				    pid: pid,
				    item_amount: cnt,
				    price: amount,
				    xlpa_tx: tx.result.txhash,
				    walletAddress: connectedWallet.walletAddress,
				    timestamp: new Date().toISOString(),
				    network: network.name  // 네트워크 정보도 서버에 전송
				  }),
				});
				
				const resultapi = await response.json();
				
				  console.log('서버 응답(resultapi):', resultapi); // ← 이 부분 추가
				
			     // ret이 0이 아니면(즉, 실패면) 알럿 띄우고 함수 종료
			      if (resultapi.ret === 0) {
  					alert(resultapi.msg || 'An error occurred during server processing.');
  					return;
			      }
	            
	            // 성공 결과 콘솔 출력
      			console.log("트랜잭션 성공:", tx);
      			alert(`The transaction has been successfully completed. \n TX Hash: ${tx.result.txhash}`);
				setShowCheckoutModal(false);
				setInputUserId("");
				setSelectedProduct(null);
	            
	        }
	        else setTxError("Please Retry Send!");
	    } catch (error) {
	        console.error("Transaction error:", error);
	        if (error instanceof UserDenied) {
	            setTxError("User Denied");
	            alert("Transaction was cancelled by user");
	        } else {
	            setTxError("Unknown Error: " + (error instanceof Error ? error.message : String(error)));
	            alert("Transaction failed: " + (error instanceof Error ? error.message : String(error)));
	        }
	    }
	};

    useEffect(() => {
        if (txResult && loading !== 0) {
            const timer = setTimeout(async () => {
                try {
                    const txInfo = await lcd.tx.txInfo(txResult.result.txhash);
                    
                    if(txInfo.code === 5) {
 						setLoading(loading + 1);
					}
                    
                    if (txInfo.txhash) setLoading(0);
                } catch (err) {
                    setLoading(loading + 1);
                }
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [loading]);

  	// PC에서만 자동 팝업 표시
	useEffect(() => {
		if (!IS_MOBILE && !IS_XPLA_INSTALLED) {
			setShowWalletInstallModal(true);
		}
	}, []);
	
	// 네트워크 변경 감지 및 경고
	useEffect(() => {
	    if (connectedWallet && network) {
	        console.log("Connected Network:", network.name);
	        console.log("Expected Network:", EXPECTED_NETWORK);
	        
	        if (network.name !== EXPECTED_NETWORK) {
	            console.warn(`⚠️ Warning: Connected to ${network.name} but expected ${EXPECTED_NETWORK}`);
	        }
	    }
	}, [connectedWallet, network]);
  
  
  //현재 지갑 잔액 가져오기 
	const [balance, setBalance] = useState("0.000000");
	
	const fetchBalance = async (address) => {
	  try {
	    const balances = await lcd.bank.balance(address); // [Coins]
	    const axpla = balances[0].get("axpla");
	    if (axpla) {
	      // amount는 Decimal 객체이므로 toString()으로 변환
	      const axplaAmount = BigInt(axpla.amount.toString());
	      const integerPart = axplaAmount / 1000000000000000000n; // 1,000,000n (6자리)
	      const fractionalPart = axplaAmount % 1000000000000000000n;
	      const fractionalStr = fractionalPart.toString().padStart(6, "0");
	      const xplaStr = `${integerPart}.${fractionalStr}`;
	      console.log(`XPLA: ${xplaStr}`);
	      setBalance(xplaStr);
	    } else {
	      setBalance("0.000000");
	    }
	  } catch (e) {
	    setBalance("0.000000");
	  }
	};
	
	useEffect(() => {
	  if (connectedWallet && connectedWallet.walletAddress) {
	    fetchBalance(connectedWallet.walletAddress);
	  }
	}, [connectedWallet]);
  //현재 지갑 잔액 가져오기 
  
  if (!show) return null;

  return (
    <>
      <header className="header">
        <div className="logo">
          <img src="./images/logo.png" alt="Logo" className="header-logo" />
          Bungeoppang Tycoon Shop
        </div>
        
        {/* 네트워크 상태 표시 (선택사항 - 필요시 주석 해제) */}
        {network && connectedWallet && (
          <div style={{
            position: 'absolute',
            top: '60px',
            right: '20px',
            padding: '8px 12px',
            borderRadius: '6px',
            backgroundColor: network.name === EXPECTED_NETWORK ? 'rgba(40, 167, 69, 0.9)' : 'rgba(220, 53, 69, 0.9)',
            color: 'white',
            fontSize: '11px',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            zIndex: 100
          }}>
            <div style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              backgroundColor: 'white',
              opacity: network.name === EXPECTED_NETWORK ? 1 : 0.8
            }}/>
            {network.name === EXPECTED_NETWORK ? (
              `✓ ${network.name.toUpperCase()}`
            ) : (
              `⚠️ ${network.name.toUpperCase()} (Need ${NETWORK_DISPLAY_NAME})`
            )}
          </div>
        )}
        
        {/* 모바일에서는 status 체크 없이 바로 Connect 버튼 표시 */}
        {IS_MOBILE ? (
          // 모바일: status와 관계없이 버튼 표시
          connectedWallet ? (
            <div className="wallet-connected-container">
              <button 
                className="connect-btn connected" 
                onClick={() => setShowWalletMenu(!showWalletMenu)}
              >
                <div className="wallet-status"></div>
                {connectedWallet.walletAddress.slice(0, 6)}...{connectedWallet.walletAddress.slice(-4)}
              </button>
              
              {showWalletMenu && (
                <div 
                  className="wallet-menu"
                  onMouseLeave={() => setShowWalletMenu(false)}
                >
                  <a 
                    href={`https://explorer.xpla.io/mainnet/address/${connectedWallet.walletAddress}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="wallet-menu-item"
                  >
                    <img src="./images/external-link.svg" alt="Explorer" className="menu-icon" />
                    <span>View on explorer</span>
                  </a>
                  <button 
                    className="wallet-menu-item"
                    onClick={() => {
                      disconnect();
                      setShowWalletMenu(false);
                    }}
                  >
                    <img src="./images/disconnect.svg" alt="Disconnect" className="menu-icon" />
                    <span>Disconnect</span>
                  </button>
                </div>
              )}
            </div>
          ) : (
            <button 
              className="connect-btn"  
              onClick={() => {
                console.log("Mobile Connect button clicked");
                connect();
              }}
            >
              <svg className="wallet-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M21 8h-3V6.5C18 4.57 16.43 3 14.5 3h-9C3.57 3 2 4.57 2 6.5v11C2 19.43 3.57 21 5.5 21h13c1.93 0 3.5-1.57 3.5-3.5v-6c0-1.93-1.57-3.5-3.5-3.5zM5.5 5h9c.83 0 1.5.67 1.5 1.5V8H5.5C4.67 8 4 7.33 4 6.5S4.67 5 5.5 5zm13 14h-13C4.67 19 4 18.33 4 17.5V9.95c.49.3 1.03.5 1.5.5h13c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5z"/>
                <circle cx="16" cy="13.5" r="1.5"/>
              </svg>
              <span style={{ color: "#fff" }}>Connect</span>
            </button>
          )
        ) : (
          // PC: 기존 로직 유지
          status === WalletStatus.WALLET_NOT_CONNECTED ? (
            <button 
              className="connect-btn"  
              onClick={() => {
                console.log("PC Connect button clicked");
                console.log("Is XPLA Installed:", isXplaInstalled);
                
                if (!isXplaInstalled) {
                  console.log("PC - Extension not installed, showing install modal");
                  setShowWalletInstallModal(true);
                } else {
                  console.log("PC - Extension installed, calling connect()");
                  connect();
                }
              }}
            >
              <svg className="wallet-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M21 8h-3V6.5C18 4.57 16.43 3 14.5 3h-9C3.57 3 2 4.57 2 6.5v11C2 19.43 3.57 21 5.5 21h13c1.93 0 3.5-1.57 3.5-3.5v-6c0-1.93-1.57-3.5-3.5-3.5zM5.5 5h9c.83 0 1.5.67 1.5 1.5V8H5.5C4.67 8 4 7.33 4 6.5S4.67 5 5.5 5zm13 14h-13C4.67 19 4 18.33 4 17.5V9.95c.49.3 1.03.5 1.5.5h13c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5z"/>
                <circle cx="16" cy="13.5" r="1.5"/>
              </svg>
              <span style={{ color: "#fff" }}>Connect</span>
            </button>
          ) : (
            <div className="wallet-connected-container">
              <button 
                className="connect-btn connected" 
                onClick={() => setShowWalletMenu(!showWalletMenu)}
                onMouseEnter={() => setShowWalletMenu(true)}
              >
                <div className="wallet-status"></div>
                {connectedWallet?.walletAddress.slice(0, 6)}...{connectedWallet?.walletAddress.slice(-4)}
              </button>
              
              {showWalletMenu && (
                <div 
                  className="wallet-menu"
                  onMouseLeave={() => setShowWalletMenu(false)}
                >
                  <a 
                    href={`https://explorer.xpla.io/mainnet/address/${connectedWallet?.walletAddress}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="wallet-menu-item"
                  >
                    <img src="./images/external-link.svg" alt="Explorer" className="menu-icon" />
                    <span>View on explorer</span>
                  </a>
                  <button 
                    className="wallet-menu-item"
                    onClick={() => {
                      disconnect();
                      setShowWalletMenu(false);
                    }}
                  >
                    <img src="./images/disconnect.svg" alt="Disconnect" className="menu-icon" />
                    <span>Disconnect</span>
                  </button>
                </div>
              )}
            </div>
          )
        )}
      </header>

		{/* PC용 설치 안내 모달 - 모바일에서는 표시 안 함 */}
		{!isMobile && !isXplaInstalled && showWalletInstallModal && (
		  <div className="modal-overlay">
		    <div className="checkout-modal">
		      <div className="checkout-header">
		        <h2 className="checkout-title">🚨 XPLA Vault Wallet Required</h2>
		        <button 
		          className="checkout-close"
		          onClick={() => setShowWalletInstallModal(false)}
		        >
		          ✕
		        </button>
		      </div>
		      
		      <div style={{ marginBottom: "24px", lineHeight: "1.6", color: "#999" }}>
		        XPLA Vault Wallet is not installed.<br />
		        Please install the wallet first to use our service.
		      </div>
		      
		      <div className="checkout-buttons">
				<button
				  className="checkout-btn-buy"
				  onClick={() => {
				    window.open("https://chromewebstore.google.com/detail/xpla-vault-wallet/ocjobpilfplciaddcbafabcegbilnbnb", "_blank", "noopener,noreferrer");
				    setShowWalletInstallModal(false);
				  }}
				>
				  Install Now
				</button>
		      </div>
		    </div>
		  </div>
		)}

      <section className="festival-banner-wrapper">
        <div className="festival-banner" onClick={openTelegram}>
          <img 
            className="banner-image"
            src="./images/bloom-boost-banner.png" 
            alt="Bloom Boost Festival"
          />
        </div>
      </section>
      
	  <section className="game-section">
		<div className="game-header">
		  <div className="game-icon">💎</div>
		  <h2 className="game-title">Game Items</h2>
		</div>
		
		<div className="product-grid">
		  {products.map(product => (
			<div 
			  className="product-card" 
			  key={product.pid}
			  onClick={() => {
				console.log("Product card clicked");
				console.log("Connection status:", status);
				console.log("Is Mobile:", isMobile);
				
				if (status !== WalletStatus.WALLET_CONNECTED) {
				  // 연결되지 않은 상태
				  if (isMobile) {
				    // 모바일: 바로 connect() 호출
				    console.log("Mobile - calling connect() from product card");
				    connect();
				  } else {
				    // PC: Extension 체크
				    if (!isXplaInstalled) {
				      console.log("PC - showing install modal from product card");
				      setShowWalletInstallModal(true);
				    } else {
				      console.log("PC - calling connect() from product card");
				      connect();
				    }
				  }
				} else {
				  // 이미 연결된 상태: 네트워크 체크 후 구매 모달 표시
				  if (network && network.name !== EXPECTED_NETWORK) {
				      alert(`⚠️ Wrong Network!\n\nPlease switch to ${NETWORK_DISPLAY_NAME} network first.\n\nCurrent: ${network.name.toUpperCase()}`);
				      return;
				  }
				  setSelectedProduct(product);
				  setShowCheckoutModal(true);
				}
			  }}
			>
			  <div className="coin-icon">
				<img 
				  className="coin-image"
				  src={`./images/coin-${product.icon}.png`}
				  alt={product.name}
				  onError={(e) => {
				    e.target.style.display = 'none';
				  }}
				/>
			  </div>
			  <h3 className="product-name">{product.name}</h3>
			  <div className="product-prices">
				<div className="xpla-price">
				  <img className="xpla-icon" src="./images/xpla-icon.svg" alt="XPLA" />
				  <span className="price-amount">{product.xplaPrice}</span>
				</div>
			  </div>
			</div>
		  ))}
		</div>

		{/* Checkout 모달 */}
		{showCheckoutModal && selectedProduct && (
		  <div className="modal-overlay">
			<div className="checkout-modal">
			  <div className="checkout-header">
				<h2 className="checkout-title">Checkout</h2>
				<button 
				  className="checkout-close"
				  onClick={() => {
					setShowCheckoutModal(false);
					setInputUserId("");
					setSelectedProduct(null);
				  }}
				>
				  ✕
				</button>
			  </div>
			  
			  {/* 네트워크 경고 표시 (잘못된 네트워크일 때만) */}
			  {network && network.name !== EXPECTED_NETWORK && (
			    <div style={{
			      margin: '10px',
			      padding: '10px',
			      backgroundColor: '#f8d7da',
			      color: '#721c24',
			      borderRadius: '5px',
			      fontSize: '14px',
			      textAlign: 'center'
			    }}>
			      ⚠️ Wrong Network: {network.name.toUpperCase()}<br/>
			      Please switch to {NETWORK_DISPLAY_NAME}
			    </div>
			  )}
			  
			  <div className="checkout-item">
				<div className="checkout-coin-image">
				  <img 
					src={`./images/coin-${selectedProduct.pid}.png`}
					alt={selectedProduct.name}
					onError={(e) => {
					  e.target.style.display = 'none';
					}}
				  />
				</div>
				<div className="checkout-item-info">
				  <div className="checkout-item-name">{selectedProduct.name}</div>
				</div>
			  </div>
			  
			  <div className="checkout-price-section">
				<div className="price-row">
				  <span className="price-label">Price</span>
				  <span className="price-value">{selectedProduct.xplaPrice} XPLA</span>
				</div>
				<div className="price-row">
				  <span className="price-label">Fee</span>
				  <span className="price-value">0.040000 XPLA</span>
				</div>
				<div className="price-row">
				  <span className="price-label">Network</span>
				  <span className="price-value" style={{
				    color: network?.name === EXPECTED_NETWORK ? '#28a745' : '#dc3545'
				  }}>
				    {network ? network.name.toUpperCase() : 'NOT CONNECTED'}
				  </span>
				</div>
				<div className="price-row price-total">
				  <span className="price-label">Balance</span>
				  <span className="price-value"> {Number(balance).toFixed(6)}   XPLA</span>
				</div>
				<div className="price-row">
				  <span className="price-label">Balance after transaction</span>
				  <span className="price-value price-negative"> {(balance && selectedProduct) 
      				? (Number(balance) - Number(selectedProduct.xplaPrice)).toFixed(6) 
      				: "0.000000"} XPLA</span>
				</div>
			  </div>
			  
			  <div className="checkout-input-section">
				<label className="checkout-label" htmlFor="gameUid">
				  Game UID
				</label>
				<input
				  id="gameUid"
				  className="checkout-input"
				  type="text"
				  placeholder="Enter your UID"
				  value={inputUserId}
				  maxLength={11}
				  onChange={e => {
					const onlyNums = e.target.value.replace(/[^0-9]/g, "");
					setInputUserId(onlyNums);
				  }}
				  autoFocus
				/>
				{inputUserId.length > 0 && inputUserId.length !== 11 && (
				  <div className="checkout-warning">
					Please enter 11-digit UID
				  </div>
				)}
			  </div>
			  
			  <div className="checkout-payment-section">
				<label className="checkout-label">Payment Methods</label>
				<div className="payment-method">
				  <img className="payment-icon" src="./images/xpla-icon.svg" alt="XPLA" />
				  <span>XPLA</span>
				</div>
			  </div>
			  
			  <div className="checkout-buttons">
				<button
				  className="checkout-btn-close"
				  onClick={() => {
					setShowCheckoutModal(false);
					setInputUserId("");
					setSelectedProduct(null);
				  }}
				>
				  Close
				</button>
				<button
				  className={`checkout-btn-buy ${inputUserId.length !== 11 ? 'disabled' : ''}`}
				  onClick={() => {
				//	console.log("Buy Now 클릭됨");
				//	console.log("UID 길이:", inputUserId.length);
				//	console.log("UID:", inputUserId);
					if (inputUserId.length === 11) {
				//	  console.log("handleSend 호출");
					  handleSend({ ...selectedProduct, userId: inputUserId });
					} else {
					  console.log("UID 길이가 11자리가 아님");
					}
				  }}
				  disabled={inputUserId.length !== 11}
				>
				  Buy Now
				</button>
			  </div>
			</div>
		  </div>
		)}
	  </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src="./images/logo.png" alt="Bungeoppang Tycoon" className="footer-logo-img" />
            <span className="footer-logo-text">Bungeoppang Tycoon</span>
          </div>
          
          <div className="social-links">
            <a href="https://discord.gg/q9Hmtjx3" target="_blank" rel="noopener noreferrer" className="social-link">
              <img src="./images/discord.svg" alt="Discord" />
            </a>
            <a href="https://x.com/XPLA_Official" target="_blank" rel="noopener noreferrer" className="social-link">
              <img src="./images/twitter.svg" alt="Twitter" />
            </a>
            <a href="https://www.xpla.io/ja?utm_source=XPLA_linktree&utm_medium=sns&utm_campaign=XPLAIO" target="_blank" rel="noopener noreferrer" className="social-link">
              <img src="./images/gitbook.svg" alt="Docs" />
            </a>
          </div>
          
          <ul className="footer-links">
            <li>
              <a href="https://sites.google.com/view/arum-ganes/home/terms-of-servic" target="_blank" rel="noopener noreferrer">
                Terms of Service
              </a>
            </li>
          </ul>
          
          <p className="copyright">Copyright © 2025 All Rights Reserved.</p>
        </div>
      </footer>

      {txResult && (
        <div style={{ marginTop: 20 }}>
          <div className="info-title">Send Transaction Hash</div>
          <div className="info-content">
            {
              loading !== 0 ?
                <span>Loading...</span>
                :
                <a
                  className="link"
                  href={"https://explorer.xpla.io/" + network.name + "/tx/" + txResult.result.txhash}
                  target="_blank"
                  rel="noreferrer"
                >
                  {txResult.result.txhash}
                </a>
            }
          </div>
        </div>
      )}
      {txError && (
        <div style={{ marginTop: 20 }}>
          <div className="info-title">Tx Error</div>
          <div className="info-content">
            <span>
              {txError}
            </span>
          </div>
        </div>
      )}
      {children}
    </>
  );
}